import { defineAction } from '~/prix'
import { z } from 'zod'
import creditSoldProductFetchAction from './creditSoldProductFetch.action.json' with { type: 'json' }
import { creditSoldProductObject } from '../creditSoldProductObject'

const creditSoldProductFetchDefinition = defineAction({
  ...creditSoldProductFetchAction,

  input: z.object({
    id: creditSoldProductObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: creditSoldProductObject,
})

export default creditSoldProductFetchDefinition

